module.exports = __webpack_public_path__ + "img/ball.34de761d.png";